module.exports = __webpack_public_path__ + "img/beer_id-64.80ffbe4d.png";